// utils/filterIndianLanguages.js
export const filterIndianLanguages = (value) => {
  return value.replace(/[\u0900-\u0D7F]/g, ''); // blocks all major Indian scripts
};